import { RootState } from '../../store.model';
import { getMyWorkspaceSelector } from '../../stoerkID/selectors/StoerkId.selectors';
import IncidentAPI from '../api/IncidentAPI';
import type { getAlarmsBySelectorProps } from './getAlarmBySelector';
import { createSelector } from '@reduxjs/toolkit';

export const getMyIncidentsSelector = createSelector(
  [
    (state: RootState) => state,
    getMyWorkspaceSelector,
    (_state: RootState, props: getAlarmsBySelectorProps) =>
      props.filterByActive,
  ],
  (state, workspace, filterByActive) => {
    const workspaceId = workspace?.id ?? '';
    return IncidentAPI.endpoints.getMyIncidentByWorkspaceId.select({
      workspaceId,
      filterByActive,
    })(state);
  }
);
